import React, {Component} from 'react';
import {Card, CardText, CardTitle, Col} from "reactstrap";
import {API_URL} from "../../config/Config";
import {connect} from "react-redux";

class PlanItem extends Component {

    render() {
        const {data, businessId} = this.props;

        return (
            <Col md="6" sm="12">
                <Card body inverse={false} className='plan-card mb-5 text-center'>
                    <CardTitle>{data.title}</CardTitle>
                    <CardText>{data.description}</CardText>
                    <a className="btn btn-default btn-block"
                       href={`${API_URL}business/buy/${businessId}?plan_id=${data.id}&api_token=${this.props.user.apiToken}`}
                       target='_blank'>خرید و فعال سازی ({data.price} تومان)</a>
                </Card>
            </Col>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, null)(PlanItem);





// WEBPACK FOOTER //
// ./src/components/plans/PlanItem.js